// ----------------------------------------------------------------------

export default function Link() {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          color: '#004040',
          '&:hover': { color: '#005b5b' },
          '&:active': { color: '#005b5b' },
        },
      },
    },
  };
}
